import React from 'react';
import './Testimonials.css';

import { Heading } from '../../../components';
import { testiContent } from '../../../constants';

import { FaQuoteRight, FaQuoteLeft } from 'react-icons/fa';

// Import Swiper core and required modules
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles  
import 'swiper/css'; 
import 'swiper/css/pagination';
import 'swiper/css/navigation';



const Testimonials = () => {
  return (
    <section className='testimonials'>

      {/* Section heading */}
      <Heading title={'Attendee Testimonials'} subTitle={`What Attendees Say`} />

      <div className='testimonial-slider'>

        <Swiper

          // Install Swiper modules
          modules={[Pagination, Navigation, Autoplay]} // Enable Pagination & Autoplay
          spaceBetween={10} // Space between slides
          loop={true} // Infinite Looping
          autoplay={{ delay: 4000, disableOnInteraction: false }} // Auto-slide every 4 seconds
          navigation
          pagination={{ clickable: true }} // Enable pagination dots

        >
          {/* Map over the testiContent array to render each testimonial */}
          {testiContent.map((testimonial) => {

            // Destructure testimonial object
            const { id, image, content, name, title } = testimonial;

            return (
              <SwiperSlide className='testi-item' key={id}>

                <FaQuoteLeft className='quote-left'/> {/* Testimonial Quote Left icon */}
                <FaQuoteRight className='quote-right'/> {/* Testimonial Quote Right icon */}

                <img src={image} alt={name} /> {/* User Image */}

                <p>"{content}"</p> {/* Testimonial */}

                <h4>{name}</h4> {/* Author name */}
                <h6>{title}</h6> {/* Author title */}

              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
}

export default Testimonials;